import React, { memo } from "react";
import { Box,  Divider, IconButton, Link, Tooltip } from "@mui/material";
import { Done, EditRounded } from "@mui/icons-material";
import { CardContainer } from "../../OrderRequestDetail.style";
import { ORDER_ITEM_STATUS } from "../../constant";
import Typography from "../../../Typography/Typography";
import { OrderDetails } from "../../types";
import { Button } from "component/MarketPlace/ButtonComponents";

type Props = {
  orderDetails: OrderDetails;
  onApprove: () => void;
  onDecline: () => void;
  setOpenEditOrderDetailCard: (isOpen: boolean) => void;
  isApprovalPage?: boolean;
  userMarketplace?: Record<string, any>;
  locale: any;
};

const OrderDetailsCard = ({
  orderDetails,
  onApprove,
  onDecline,
  setOpenEditOrderDetailCard,
  isApprovalPage,
  locale,
}: Props) => {
  const orderStatus = orderDetails?.status === ORDER_ITEM_STATUS.CANCELED ?  orderDetails?.status : orderDetails?.approval?.approval_status;
  const requestedBy = orderDetails?.requested_by?.name || "";
  const requestedFor = orderDetails?.requested_for?.name || "";
  const approvalReason = orderDetails?.approval?.approval_reason || "";

  return (
    <>
      <CardContainer>
        <Box>
          {/* Optional Details */}
          <Box padding="12px 16px">
            <Typography variant="h6" mb={2}>
              {locale?.orderDetails}
            </Typography>
            <Box paddingBottom="24px">
              <Box
                display="flex"
                width="100%"
                justifyContent="space-between"
                alignItems="center"
                paddingBottom="8px"
              >
                <Typography variant="body2" color="text.secondary" mb={1}>{locale?.costCenterCode}</Typography>
                {orderStatus === ORDER_ITEM_STATUS.PENDING && (
                  <Tooltip title="Edit">
                    <IconButton
                      onClick={() => setOpenEditOrderDetailCard?.(true)}
                      size="small"
                      aria-label="Open edit order detail card button"
                    >
                      <EditRounded />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
              <Typography variant="body1">
                {orderDetails?.cost_center || ""}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary" mb={1}>
                {locale?.businessJustification}
              </Typography>
              <Typography variant="body1">
                  N/A
              </Typography>
            </Box>
            {requestedFor &&
              <Box paddingTop="24px">
                <Typography variant="body2" color="text.secondary" mb={1}>
                  {locale?.requestedFor}
                </Typography>
                <Typography variant="body1" id="lbl-orderdetails-requested_for">
                  {requestedFor}
                </Typography>
              </Box>
            }
            {requestedBy &&
              <Box paddingTop="24px">
                <Typography variant="body2" color="text.secondary" mb={1}>
                  {locale?.requestedBy}
                </Typography>
                <Typography variant="body1" id="lbl-orderdetails-requested_by">
                  {requestedBy}
                </Typography>
              </Box>
            }
            {orderStatus === ORDER_ITEM_STATUS.CANCELED &&
              <Box paddingTop="24px">
                <Typography variant="body2" color="text.secondary" mb={1}>
                  {locale?.approvalReason}
                </Typography>
                <Typography variant="body1" id="lbl-orderdetails-approval_reason">
                  {approvalReason || 'N/A'}
                </Typography>
              </Box>
            }
          </Box>
        </Box>
        {orderStatus === ORDER_ITEM_STATUS.PENDING && isApprovalPage && (
          <>
            <Divider sx={{ my: 2 }} />
            <Box display="flex" gap={2}>
              <Button variant="outlined" size="large" fullWidth onClick={onDecline} id="btn-orderdetails-decline">
                {locale?.decline}
              </Button>
              <Button variant="contained" startIcon={<Done fontSize="small" />} size="large" fullWidth onClick={onApprove} id="btn-orderdetails-approve">
                {locale?.approve}
              </Button>
            </Box>
            <Box mt={1.5}>
              <Typography variant="caption" color="text.secondary">
                {locale?.byClickingTheApproveButton}{" "}
                <Link href="#" underline="always" color="inherit">
                  {locale?.termsOfService}
                </Link>{" "}
                {locale?.andTheOrder}
              </Typography>
            </Box>
          </>
        )}
      </CardContainer>
    </>
  );
};

export default memo(OrderDetailsCard);
